import { h } from 'preact';
import { CheckboxEntry } from '../entries/CheckboxEntry';

const TASK_TYPES = ['epx:UserTask', 'epx:ManualTask'];

export class AdminProcessPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    const boolField = (propKey, label) => ({
      id: propKey,
      component: () => (
        <CheckboxEntry
          id={`epx-${propKey}`}
          label={label}
          checked={props[propKey] === true || props[propKey] === 'true'}
          onChange={(val) => update(propKey, val)}
        />
      ),
    });

    return [
      {
        id: 'adminProcess',
        label: i18n.adminProcess || 'Admin Process',
        entries: [
          boolField('automaticAssignment', i18n.automaticAssignment || 'Automatic Assignment'),
          boolField('approvalRequired', i18n.approvalRequired || 'Approval Required'),
          boolField('sendBackActivity', i18n.sendBackActivity || 'Allow Send Back'),
          boolField('electDocRequired', i18n.electDocRequired || 'Electronic Doc Required'),
          boolField('publishDocument', i18n.publishDocument || 'Publish Document'),
          boolField('publishAttachments', i18n.publishAttachments || 'Publish Attachments'),
        ],
      },
    ];
  }
}
